<cbc-container [isLoading]="false" [showContainer]="true" [title]="getPageTitle()"
  [description]="getProductTypeEnumDescription(productPackageType)">
</cbc-container>

@if(providerPJForm && !isLoading){
<div class="container" [class.is_mobile]="isMobile">

  <div class="swiper-menu">
    <div class="mini-card-container">
      <div class="mini-card" [class.selected]="selectedTab.value === 'tab1'" (click)="selectedTab.setValue('tab1')">
        <img src="assets/icons/icon_conta_editar_dadospessoais.svg" alt="" width="40px">
        <span>Dados da Empresa</span>
      </div>

      <div class="mini-card" *ngIf="providerPJForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab2'"
        (click)="selectedTab.setValue('tab2')">
        <img src="assets/icons/icon_conta_editar_controledeacessos.svg" alt="" width="40px">
        <span>Controle de acessos</span>
      </div>

      <div class="mini-card" *ngIf="providerPJForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab3'"
        (click)="selectedTab.setValue('tab3')">
        <img src="assets/icons/icon_conta_editar_documentos.svg" alt="" width="40px">
        <span>Documentos</span>
      </div>

      <div class="mini-card" *ngIf="providerPJForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab4'"
        (click)="selectedTab.setValue('tab4')">
        <img src="assets/icons/icon_conta_editar_enderecos.svg" alt="" width="40px">
        <span>Endereços</span>
      </div>

      <div class="mini-card" *ngIf="providerPJForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab5'"
        (click)="selectedTab.setValue('tab5')">
        <img src="assets/icons/icon_conta_editar_certificados.svg" alt="" width="40px">
        <span>Certificados</span>
      </div>
    </div>
  </div>
</div>

<app-swiper swiperContainerId="why-us-swiper">
  <swiper-container #swiper class="swiper" pagination="false" autoplay="false">
    <swiper-slide>
      <div class="slideContainer">
        @if(providerPJForm){
        <div class="form-container" [class.is_mobile]="isMobile">
          <form [formGroup]="providerPJForm">
            <!-- Dados Básicos -->
            <div class="row">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Razão Social</mat-label>
                <input matInput formControlName="companyName" />
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Nome Fantasia</mat-label>
                <input matInput formControlName="companyMarketingName" />
              </mat-form-field>
            </div>

            <div class="row-2-col">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>CNPJ</mat-label>
                <input matInput formControlName="cnpj" [showMaskTyped]="true" mask="00.000.000/0000-00" />
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Nr. Telefone</mat-label>
                <input matInput formControlName="phoneNumber" [showMaskTyped]="true"
                  mask="(00) 0000-0000||(00) 00000-0000" />
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" [email]="true" />
              </mat-form-field>
            </div>

            <!-- Dados do Prestador (Só aparecem se for provider) -->
            @if(isProvider()){
            <h3 class="title-secondary" style="margin-top: 20px; margin-bottom: 10px;">Dados do Estabelecimento</h3>

            <div class="row-2-col">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Tipo de empresa</mat-label>
                <mat-select formControlName="businessType">
                  @for(businessType of businessTypes; track businessType){
                  <mat-option [value]="businessType.code">{{
                    businessType.description
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Código CNES</mat-label>
                <input matInput formControlName="cnesCode" type="text" mask="0*" [showMaskTyped]="false" />
              </mat-form-field>
            </div>

            <div class="row-2-col">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Registro Conselho Técnico</mat-label>
                <input matInput formControlName="crmTechnicalNumber" />
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Alvará de funcionamento</mat-label>
                <input matInput formControlName="businesLicenseControlNumber" />
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Alvará Bombeiros</mat-label>
                <input matInput formControlName="pumblerLicenseControlNumber" />
              </mat-form-field>
            </div>
            }
          </form>

          <div class="footerButtons">
            <button (click)="saveProfileProviderPJ()" [hidden]="!isEditMode" mat-flat-button color="primary"
              [disabled]="!providerPJForm.valid">
              Salvar
            </button>

            <button mat-flat-button color="primary" (click)="editMode(true)" [hidden]="isEditMode">
              Editar
            </button>
          </div>
        </div>
        }
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slideContainer">
        @if (providerPJ && providerPJ.providerPJUser) {
        <div class="container">
          <table mat-table [dataSource]="providerPJ.providerPJUser" class="mat-elevation-z8 mobile-responsive-table"
            [class.is_mobile]="isMobile">
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>
                Email
              </th>
              <td mat-cell *matCellDef="let element">{{
                element.user.email
                }}</td>
            </ng-container>

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef>
                Nome
              </th>
              <td mat-cell *matCellDef="let element">{{
                element.user.firstName
                }}</td>
            </ng-container>

            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef>
                Sobrenome
              </th>
              <td mat-cell *matCellDef="let element">{{ element.user.lastName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="mobile">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="td_mobile">
                {{ element.user.email }} <br />
                {{ element.user.firstName }} {{ element.user.lastName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="permitions">
              <th mat-header-cell *matHeaderCellDef class="td_permitions">
                Permissões
              </th>
              <td mat-cell *matCellDef="let element" class="td_permitions">
                <mat-radio-group [disabled]="user?.email === element.user.email" aria-label="Select an option"
                  [value]="element.role" (change)="updateUserRole(element, $event.value)">
                  @if(element.role === 'OWNER'){
                  <mat-radio-button disabled value="OWNER">Proprietário</mat-radio-button>
                  }
                  @if(element.role !== 'OWNER'){
                  <mat-radio-button value="LEADER">Líder</mat-radio-button>
                  <mat-radio-button value="MEMBER">Acesso</mat-radio-button>}
                </mat-radio-group>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="col-actions">
                <button mat-icon-button (click)="addUser()">
                  <mat-icon matTooltip="Conceder Acesso a Novo Usuário">add</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let element" class="col-actions">
                @if(user?.email !== element.user.email && element.role !== 'OWNER'){

                <button mat-icon-button (click)="removeUser(element.id)" matTooltip="Remover Usuário">
                  <mat-icon>delete</mat-icon>
                </button>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['email', 'firstName', 'lastName', 'permitions', 'actions']"
              class="mat-header-row"></tr>
            <tr mat-row matRipple
              *matRowDef="let row; columns: isMobile ? ['mobile', 'permitions', 'actions'] : ['email', 'firstName', 'lastName', 'permitions', 'actions']"
              class="mat-row"></tr>
          </table>

          <div class="footerButtons">
            <button mat-flat-button color="primary" (click)="addUser()">
              Conceder Acesso a Novo Usuário
            </button>
          </div>
        </div>
        }
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slideContainer">
        <div class="container">
          @if(providerPJForm && providerPJForm.controls['id'].value ){
          <app-attachment
            [documentTypesRequired]="providerPJForm.value.profile === 'CONTRACTOR_PJ'? documentTypesRequiredContractor:documentTypesRequired"
            [ownerDocumentsCpfCnpj]="providerPJForm.controls['cnpj'].value"></app-attachment>
          }
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slideContainer">
        <app-address-list [addresses]="addresses" (addAddress)="openAddressDialog()"
          (deleteAddress)="deleteAddress($event)" (editAddress)="editAddress($event)"
          (setCommercialAddress)="setCommercialAddress($event)">
        </app-address-list>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="slideContainer">
        <div class="form-container" [class.is_mobile]="isMobile">
          <div class="card">
            @if(providerPJForm.controls["id"].value){

            <div class="info-row">
              <span class="info-label">Dados da Empresa:</span>
              <span class="info-separator"></span>
              <span class="info-data">
                @if (checkCertifiedCompanyData()){
                <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical" width="24px"
                  alt="">
                } @else {
                <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Certificado Hub Medical" width="24px"
                  alt="">
                }
              </span>
            </div>

            <div class="info-row">
              <span class="info-label">Documentos:</span>
              <span class="info-separator"></span>
              <span class="info-data">
                @if (checkCertifiedDocuments()){
                <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical" width="24px"
                  alt="">
                } @else {
                <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Certificado Hub Medical" width="24px"
                  alt="">
                }
              </span>
            </div>

            <div class="info-row">
              <span class="info-label">Endereços:</span>
              <span class="info-separator"></span>
              <span class="info-data">
                @if (checkCertifiedAddress()){
                <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical" width="24px"
                  alt="">
                } @else {
                <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Certificado Hub Medical" width="24px"
                  alt="">
                }
              </span>
            </div>


            <div class="info-row">
              <span class="info-label">Data do cadastro:</span>
              <span class="info-separator"></span>
              <span class="info-data">
                {{
                providerPJForm.controls["registerDate"].value
                | date : "dd/MM/yyyy"
                }}
              </span>
            </div>

            <div class="info-row">
              <span class="info-label">Status:</span>
              <span class="info-separator"></span>
              <strong class="info-data">{{ providerPJForm.controls["status"].value | enumDescription }}</strong>
            </div>

            <div style="margin-top: 20px;">
              <app-certification-button color="warn"
                [subject]="'Solicito certificado para a perfil PJ ID:' + providerPJForm.controls['id'].value"
                [itemId]="providerPJForm.controls['id'].value" [certified]="checkAllCertification()">
              </app-certification-button>
              <div style="margin-top: 10px; font-size: small; color: var(--color-text-secondary);">
                Observação: Para obter o certificado, todos os itens acima devem estar com o selo concedido.
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</app-swiper>
}